module.exports = __webpack_public_path__ + "static/media/za.70a290af.svg";